<script>
    import Typography from './Typography.svelte'
    import { writable } from 'svelte/store'
    import { fade } from 'svelte/transition'
    import { range, capitalize } from '$lib/utils'
    export let waitingSignals = writable(0)
    export let data = writable([])
    export let schema = {}
    export let currentPage = 1
    export let pageSize = 15
    export let pagination = {}
    let neutralFunction = (n) => n
    function calcSchema() {
        // console.log('calcSchema')
        schema = Object.fromEntries(
            Object.entries(schema).map(([colId, col]) => {
                return [
                    colId,
                    {
                        label: capitalize(col.label || colId).replace(
                            /\_|\-|\./g,
                            ' '
                        ),
                        render: col.render || neutralFunction,
                    },
                ]
            })
        )
    }
    calcSchema()
    $: offset = (currentPage - 1) * pageSize
    $: limit = (currentPage - 1) * pageSize + pageSize
    $: total = $data instanceof Array ? $data.length : 0
    $: pagination = { offset, limit, total, currentPage, size: pageSize }
    $: if (Object.keys(schema).length == 0 && $data.length > 0) {
        schema = Object.fromEntries(Object.keys($data[0]).map((x) => [x, {}]))
        calcSchema()
    }
</script>

{#if $data.length > 0 || $waitingSignals > 0}
    <table in:fade={{ delay: 250 }} cellspacing="0">
        <thead>
            {#if !$$slots.header}
                <tr class="head">
                    {#each Object.keys(schema) as column}
                        <td
                            ><Typography type="caption" color="grey-800"
                                >{schema[column].label || column}</Typography
                            ></td
                        >
                    {/each}
                </tr>
            {:else}
                <slot name="header" />
            {/if}
        </thead>
        <tbody>
            {#if [1, null, undefined].includes(currentPage) && $waitingSignals > 0}
                {#each range($waitingSignals) as _}
                    <slot name="skeleton" />
                {/each}
            {/if}
            {#each $data.slice(offset, limit + 1) || [] as item (item.id)}
                {#if $$slots.body}
                    <slot name="body" {item} />
                {:else}
                    <tr>
                        {#each Object.keys(schema) as column}
                            <td>{@html schema[column].render(item[column])}</td>
                        {/each}
                    </tr>
                {/if}
            {/each}
        </tbody>
    </table>
{:else}
    <span
        style="border-top: 1px #CCCCCC solid; gap: 20px;justify-content: center;align-items: center;display: flex; flex-direction: column; width: 100%; padding: 35px 0"
    >
        <slot name="noContent" />
    </span>
{/if}

<style>
    table {
        border-collapse: collapse;
    }
    table,
    thead,
    tbody {
        width: 100%;
    }
    table :global(td) {
        padding: 0 24px;
    }
    table thead :global(tr) {
        height: 42px;
        background: var(--color-grey-150);
        user-select: none;
    }
    table tbody :global(tr) {
        height: 72px;
        background: #ffffff;
        border-bottom: 1px solid var(--color-grey-300);
    }
</style>
